import { newController } from 'alp-node/src';

export default newController({
  async index(ctx) {
    if (ctx.method !== 'GET') return (ctx.status = 404);
    ctx.body = '';
  },
});
